import type { NetworkDashboardStoreAgeFilter } from '@gozoki/api-types'
import type { FetchNetworkDashboardKpisParams } from './kpi.queries'

export type NetworkDashboardSection = 'sales' | 'losses' | 'categories' | 'top-products' | 'hr'

export const networkDashboardQueryKeys = {
  all: () => ['network-dashboard'] as const,
  sections: () => [...networkDashboardQueryKeys.all(), 'sections'] as const,
  sectionRoot: (section: NetworkDashboardSection) =>
    [...networkDashboardQueryKeys.sections(), section] as const,
  section: <T>(section: NetworkDashboardSection, params: T) =>
    [...networkDashboardQueryKeys.sectionRoot(section), params] as const,
  availableStores: () => [...networkDashboardQueryKeys.all(), 'available-stores'] as const,
  live: (storeIds: readonly number[], storeAgeFilter: string) =>
    [...networkDashboardQueryKeys.all(), 'live', storeIds, storeAgeFilter] as const,
}

export const normalizeNetworkDashboardSectionKeyParams = (
  storeIds: number[] | undefined,
  storeAgeFilter: NetworkDashboardStoreAgeFilter,
  period: FetchNetworkDashboardKpisParams | undefined,
) =>
  ({
    storeIds:
      storeIds === undefined ? undefined : [...storeIds].sort((left, right) => left - right),
    storeAgeFilter,
    ageStoreIds:
      period?.ageStoreIds === undefined
        ? undefined
        : [...period.ageStoreIds].sort((left, right) => left - right),
    startDate: period?.startDate,
    endDate: period?.endDate,
    activeStartDate: period?.activeStartDate,
    activeEndDate: period?.activeEndDate,
    cohortUnit: period?.cohortUnit,
    cohortValue: period?.cohortValue,
    comparisonMode: period?.comparisonMode,
  }) as const

export const networkDashboardSectionKey = (
  section: NetworkDashboardSection,
  storeIds: number[] | undefined,
  storeAgeFilter: NetworkDashboardStoreAgeFilter,
  period: FetchNetworkDashboardKpisParams | undefined,
) =>
  networkDashboardQueryKeys.section(
    section,
    normalizeNetworkDashboardSectionKeyParams(storeIds, storeAgeFilter, period),
  )
